export const rcdaNomenclatureVersionsWithLabels = [
  ['1.0-2024-11-19', { label: 'Version 1' }],
  ['1.1-2025-01-08', { label: 'Version 1.1' }],
  ['2.0-2025-02-10', { label: 'Version 2 - Mandatory 02/2025 RCDA updates' }],
  ['2.1-2025-07-01', { label: 'Version 2.1 - Update management fee and installment fee rate' }],
  ['3.0-2025-07-04', { label: 'Version 3 - RCDA v3 with extended coverage' }],
  /* Same coverage as v3. This is just a minor bump for Project Churn's [Measure 5](https://app.notion.com/p/orus-team/Tech-Scoping-ac90ab24de318301be6701911fcc734b?source=copy_link#f701560538b342b98ab534128adbbb70)
   * so the annual-payment requirement applies only from this version onwards,
   * protecting already-signed subscriptions.
   */
  ['3.1-2026-07-16', { label: 'Version 3.1 - Annual-payment requirement' }],
  ['3.2-2026-08-05', { label: 'Version 3.2 - SEPA-only payment-method restriction' }],
  ['4.0-2026-07-30', { label: 'Version 4.0 - July 2026 updates' }],
] as const

export const rcdaNomenclatureVersions = rcdaNomenclatureVersionsWithLabels.map(([version]) => version)
export type RcdaNomenclatureVersion = (typeof rcdaNomenclatureVersions)[number]
